import { inject, Injectable } from "@angular/core";
import { GetRandomExerciseOptions, ExerciseClient } from "@clients/squidex/exercise.client";
import { Exercise } from "@domain/Exercise";
import { HomophoneGroup } from "@domain/HomophoneGroup";
import { Result } from "@domain/Result";
import { Sequence } from "@domain/Sequence";

@Injectable({
  providedIn: "root",
})
export class ExerciseService {
  private exerciseClient = inject(ExerciseClient);

  getNextUnansweredExercise(homophoneGroups: HomophoneGroup[], sequence: Sequence) {
    const excludedExerciseIds = sequence.getResults().map(({ exercise }: Result) => exercise.id);
    const options = {
      homophoneGroups,
      excludedExerciseIds,
    };

    return this.fetchExercise(options);
  }

  getNextExerciseToRework(homophoneGroups: HomophoneGroup[], includedExercises: Exercise[]) {
    const includedExerciseIds = includedExercises.map(({ id }: Exercise) => id);
    const options = { homophoneGroups, includedExerciseIds };

    return this.fetchExercise(options);
  }

  private async fetchExercise(options: GetRandomExerciseOptions) {
    const exercice = await this.exerciseClient.getRandomExercise(options);

    if (!exercice) {
      throw new Error("Error fetching exercise");
    }

    return exercice;
  }
}
